import { inject, Injectable } from '@angular/core';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { Search } from '@df/search/search.interfaces';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NPageHeader } from '../../layout/page/header/page-header.interface';

@Injectable({
    providedIn: 'root'
})
export class KlevuSearchServiceDecorator extends KlevuSearchService {
    quickSearch = false;

    private iCmsBlockResource = inject(ICmsBlockResource);

    override get config(): KlevuSearch.IConfig {
        return this.app.data?.klevu || <any>{};
    }

    override isPageId(id: string): boolean {
        return id.includes('pageid');
    }

    /**
     * Retrieves category path for sort order request
     */
    override getCategoryPath(category: Category<ICategoryDataV3>): string {
        if (category.data?.klevu_breadcrumbs) {
            return category.data.klevu_breadcrumbs;
        }

        return super.getCategoryPath(category);
    }

    protected override doSearch(request: Search.IRequest): Promise<Search.IResult> {
        return new Promise((resolve, reject) => {
            let result: Search.IResult;
            let redirect: NPageHeader.IRedirect;
            Promise.all([
                super.doSearch(request).then(r => (result = r)),
                new Promise<void>(subResolve =>
                    this.iCmsBlockResource
                        .retrieve({ bareUrl: 'page-header' }, undefined)
                        .then(block => {
                            if (block) {
                                const term = request.q;
                                redirect = (block.data?.content as NPageHeader.IBlockDataContent).search_redirects?.find(item =>
                                    new RegExp(`^${item.from}$`, 'i').test(term)
                                );
                            }
                        })
                        .finally(subResolve)
                )
            ])
                .then(() => {
                    result.redirect = redirect?.to;
                    resolve(result);
                })
                .catch(reject);
        });
    }

    protected override trackSearchResult(response: KlevuSearch.ISearchResponse) {
        if (!this.quickSearch) {
            super.trackSearchResult(response);
        }
    }
}
